import packageJson from '../package.json';

const id = packageJson.name;
const SOPClassHandlerName = 'carian-diagnosis-export';
const SOPClassHandlerId = `${id}.sopClassHandlerModule.${SOPClassHandlerName}`;
export { id, SOPClassHandlerId, SOPClassHandlerName };
